import { render, staticRenderFns } from "./ListCotizacionesFact.vue?vue&type=template&id=c586ce90&"
import script from "./ListCotizacionesFact.vue?vue&type=script&lang=js&"
export * from "./ListCotizacionesFact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports